import {
  ADD_PROJECT,
  UPDATE_PROJECT,
  REMOVE_PROJECT,
  ADD_QUESTION_INTO_PROJECT,
  REMOVE_QUESTION_FROM_PROJECT
} from '../actions/projects';

import _ from 'lodash';
import { convertArrayToObject } from './../util/index';


const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_PROJECT: 
      return [ action.project, ...state ]
    case UPDATE_PROJECT:
      var index = _.findIndex(state, { id: action.project.id });
      if(state !== INITIAL_STATE) state[index] = action.project;      
      return state
    case REMOVE_PROJECT:
      var index = _.findIndex(state, { id: action.project.id });
      return (state !== INITIAL_STATE) ? state.splice(index,1) : INITIAL_STATE;
    case ADD_QUESTION_INTO_PROJECT:
      var index = _.findIndex(state,{ id: action.projectID })
      var surveyID = action.question.surveyID || ''
      var questionID = action.question.id || ''
      var key = surveyID + '_' + questionID;
      
      state[index].questions = convertArrayToObject(state[index].questions)
      state[index].questions[key] = action.question
      return state
    case REMOVE_QUESTION_FROM_PROJECT:
      var index = _.findIndex(state,{ id: action.projectID })
      // var questionIndex = _.findIndex(_.values(state[index].questions), { surveyID: action.question.surveyID, id: action.question.id })
      var surveyID = action.question.surveyID || ''
      var questionID = action.question.id || ''
      if(state[index].questions[surveyID + '_' + questionID])
        delete state[index].questions[surveyID + '_' + questionID]
      return state
    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/reducers/projects.js